export const FEE_STATUS_ERROR = "FEE_STATUS_ERROR";
export const FEE_STATUS_SUCCESS = "FEE_STATUS_SUCCESS";
export const FEE_STATUS_LOADING = "FEE_STATUS_LOADING";
export const FEE_VOUCHER_DOWNLOAD_ERROR="FEE_VOUCHER_DOWNLOAD_ERROR";
export const FEE_VOUCHER_DOWNLOAD_SUCCESS="FEE_VOUCHER_DOWNLOAD_SUCCESS";
export const FEE_VOUCHER_DOWNLOAD_LOADING="FEE_VOUCHER_DOWNLOAD_LOADING";